import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa"; // Icône de menu hamburger
import { NavLink } from "react-router-dom"; // Import de NavLink
import "./Header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  
  // Fonction pour fermer le menu
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="logo flex-shrink-0">
        {/* Ajout de NavLink autour du h1 pour la redirection vers la home page */}
        <NavLink to="/" end onClick={closeMenu}>
          <h1>AMSEBRID ◇ VOYAGEUR</h1>
        </NavLink>
      </div>

      <nav className={`nav ${menuOpen ? "active" : ""}`}>
        <ul>
          <li>
            <NavLink
              to="/"
              end
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Accueil
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/voitures"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Nos voitures
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/reservation"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Réservation
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Contact
            </NavLink>
          </li>
        </ul>
      </nav>

      <div className="menu-icon" onClick={toggleMenu}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </header>
  );
};

export default Header;
